import React from 'react';
import { SimpleTableColumnTypes, SimpleTableProps } from './simple-table.props';
import { Flex, Text } from 'common/common-components.styled';
import { StyledSpinnerContainer } from 'components/global-reference-vehicles/action-switcher/action-switcher.styled';
import Spinner from 'components/spinner';
import SimpleTableRow from './simple-table-row';

const SimpleTable = <TRow,>({ columns, rows, rowIdPropName, editRowConfig }: SimpleTableProps<TRow>) => {
  if (!rows) {
    return (
      <StyledSpinnerContainer minHeight='300px'>
        <Spinner style={spinnerStyle} />
      </StyledSpinnerContainer>
    );
  }

  return (
    <div>
      <Flex bottom='10'>
        {columns.map(column =>
          column.type === SimpleTableColumnTypes.Custom ? (
            column.headerComponent
          ) : (
            <Text
              lineHeight='24px'
              padding='0 10px'
              width={column.width || '100%'}
              bold
              color='black'
              key={column.title}
            >
              {column.title}
            </Text>
          )
        )}
      </Flex>

      {rows.map(row => (
        <SimpleTableRow key={row[rowIdPropName] as string} row={row} columns={columns} editRowConfig={editRowConfig} />
      ))}
    </div>
  );
};

const spinnerStyle = {
  width: '40px',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)'
};

export default SimpleTable;
